import React, { useEffect, useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

const ThemeToggle = () => {
  const [currentTheme, setCurrentTheme] = useState<'light' | 'dark'>(() => {
    // Get the current theme from localStorage or default to 'light'
    return (localStorage.getItem('theme') as 'light' | 'dark') || 'light';
  });

  useEffect(() => {
    // Apply the current theme to the body element
    document.body.classList.add(currentTheme);
  }, [currentTheme]);

  const toggleTheme = () => {
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    // Toggle the theme classes on the body element
    document.body.classList.remove(currentTheme);
    document.body.classList.add(newTheme);

    // Update the state and save the new theme in localStorage
    setCurrentTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <li className="nav-item">
      <button
        id="themeToggleButton"
        data-bs-toggle="tooltip"
        title="Tema"
        data-bs-placement="bottom"
        className="btn btn-primary btn-icon btn-sm rounded-pill"
        onClick={toggleTheme}
      >
        <span className="btn-inner">
          {currentTheme === 'dark' ? <FaSun /> : <FaMoon />}
        </span>
      </button>
    </li>
  );
};

export default ThemeToggle;
